import { Routes } from '@angular/router'
import { RoutesEnum } from '@ui-core/enums/routes.enum'
import { canDeactivateGuard } from '@ui-core/guards/alert-unsaved-changes.guard'
import { AuthGuard } from '@ui-core/guards/auth.guard'

export const specificationsRoutes: Routes = [
    // Specifications list route
    {
        path: RoutesEnum.SPECIFICATIONS,
        loadComponent: () => import('./specifications').then((m) => m.Specifications),
        canActivate: [AuthGuard]
    },
    {
        path: RoutesEnum.SPECIFICATION + '/new',
        loadComponent: () => import('./specification').then((m) => m.Specification),
        canActivate: [AuthGuard],
        canDeactivate: [canDeactivateGuard]
    },
    {
        path: RoutesEnum.SPECIFICATION + '/:id',
        loadComponent: () => import('./specification').then((m) => m.Specification),
        canActivate: [AuthGuard],
        canDeactivate: [canDeactivateGuard]
    }
]
